module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/stream-browserify/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 799
// module chunks = 0